import { FC } from 'react';
import { Avatar } from 'components/Avatar';
import { Phone } from 'components/Phone';
import classNames from 'classnames';
import styles from './InfoEmployeds.module.scss';
import { TextWithTooltip } from 'hooks/TextWithTooltip';

type InfoEmployedsProps = {
  name: string;
  surname: string;
  patronymic?: string;
  phone?: string;
  inn?: string;
  id: number;
  avatar: string | null;
  status?: number;
  withPhoneIcon?: boolean;
  nationality?: string;
  compact?: boolean;
  isDeleted?: boolean;
};

export const InfoEmployeds: FC<InfoEmployedsProps> = ({
  id,
  avatar,
  name = 'Исполнитель',
  surname = 'Неизвестный',
  patronymic,
  phone,
  inn,
  withPhoneIcon = true,
  nationality,
  compact = false,
  isDeleted,
}) => {
  const role = localStorage.getItem('role');
  const isWorkSupport = role === 'worksupport';

  return (
    <div className={styles.root}>
      <Avatar
        name={name}
        surname={surname}
        avatar={avatar}
        id={id}
        statusActive={''}
        isDeleted={isDeleted}
      />
      <div className={styles.text} style={{ gap: compact ? 0 : '4px' }}>
        <div className={styles.name}>
          <TextWithTooltip
            content={
              !surname
                ? name
                : patronymic
                ? `${surname} ${name} ${patronymic}`
                : `${surname} ${name}`
            }
            className={classNames(styles.name_text)}
          />
        </div>
        {(phone || (isDeleted && isWorkSupport)) && (
          <div
            className={styles.phone}
            style={{ padding: isWorkSupport ? '0 16px' : undefined }}>
            {phone && <Phone miniPhone phone={phone} withIcon={withPhoneIcon} />}
            {phone && nationality && (
              <span className={styles.nationality}>{nationality}</span>
            )}
          </div>
        )}
        {inn && <div className={styles.inn}>ИНН {inn}</div>}
      </div>
    </div>
  );
};
